export default "__VITE_PUBLIC_ASSET__6ad82823__"